import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GradeSubjectModel } from 'data/grade/grade.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: GradeSubjectModel;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: { id: '', startTime: '', endTime: '', subjects: [] },
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<GradeSubjectModel>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: { id: '', startTime: '', endTime: '', subjects: [] },
  status: 'error',
});

const gradeSubjectsSlice = createSlice({
  name: 'gradeSubjects',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default gradeSubjectsSlice;
